// extracted by mini-css-extract-plugin
module.exports = {"bottom-navigation-layout":"serviceNavigation_bottom-navigation-layout__aj6fP","container":"serviceNavigation_container__6qCdx","item":"serviceNavigation_item___aYpd"};